
        var result = require("!!../../../../../node_modules/css-loader/index.js!./oil-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/oil/oil-statistics/oil-statistics.component.css
// module id = 792
// module chunks = 0